import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home') //首页
const Profile = () => import('@/views/Profile') //公司简介
const Product = () => import('@/views/Product') //产品中心
const Solution = () => import('@/views/Solution') //解决方案
const Document = () => import('@/views/Document') //文档中心
const News = () => import('@/views/News') //新闻动态
const Contact = () => import('@/views/Contact') //联系我们
const ProductDetail = () => import('@/views/ProductDetail') //产品详情
const ThreeNav = () => import('@/views/ThreeNav')
const FourNav = () => import('@/views/FourNav')
const FiveNav = () => import('@/views/FiveNav')
const Demo = () => import('@/views/Demo')
const EnterInnovation = () => import('@/components/enter_innovation/index.vue')
const Consulting = () => import('@/components/consulting/index.vue')
const ReportList = () => import('@/components/report_list/index.vue')
const NewsDetails = () => import('@/components/report_list/NewsDetails.vue')
const NewsDetailsTwo = () => import('@/components/report_list/NewsDetailsTwo.vue')
const Realize = () => import('@/components/realize/index.vue')
// const Test = () => import('@/components/Application') //测试组件

const routes = [
  // {
  //   path: '/test',
  //   component:Test
  // },
  {
    path: '/index.html',  // 显式匹配 /index.html，并重定向到首页
    redirect: '/home'
  },
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:Home
  },
  {
	path:'/profiles',
	component:Profile
  },
  {
    path:'/product',
    component:Product,
    children:[
      {
        path:'1'
      },
      {
        path:'2'
      }
    ]
  },
  {
    path:'/productDetail',
    component:ProductDetail,
    children:[
      {
        path: ':id', // 使用 :id 作为动态参数
      }
    ]
  },
  {
  	path:'/solution',
  	component:Solution
  },
  {
  	path:'/document',
  	component:Document,
    children:[
      {
        path:'1',
      },
      {
        path:'2',
      },
	  {
	    path:'3',
	  }
    ]
  },
  {
  	path:'/news',
  	component:News
  },
  {
  	path:'/contact',
  	component:Contact
  },
  {
    path:'/threenav',
    component:ThreeNav
  },
  {
    path:'/fournav',
    component:FourNav,
    children:[
      {
        path:'1',
        component:ReportList
      },
      {
        path:'2',
        component:ReportList
      },
      {
        path:'3',
        component:ReportList
      },
    ]
  },
  {
    path:'/fivenav',
    component:FiveNav,
    children:[
      {
        path:'1',
        component:Realize
      },
      {
        path:'2',
        component:Realize
      },
      {
        path:'3',
        component:Realize
      },
      {
        path:'4',
        component:Realize
      }
    ]
  },
  {
    path:'/demo',
    component:Demo
  },
  {
    path:'/news_detail/1',
    component:NewsDetails
  },
  {
    path:'/news_detail/2',
    component:NewsDetailsTwo
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router